import "./src/styles/global.css"
import React from "react"
import LanguageProvider from "./src/components/language-provider"
import { detectLanguageFromPath } from "./src/helper/language"

export const wrapPageElement = ({ element, props }) => {
  const initialLanguage = detectLanguageFromPath(props?.location?.pathname ?? "")
  return <LanguageProvider initialLanguage={initialLanguage}>{element}</LanguageProvider>
}
